import styled from "styled-components";
import { CardProps } from "./Card.types.js";

export const StyledCard = styled.div<CardProps>`
    padding: ${(props) => `${props.theme.spacing[16]}`};
    background-color: ${(props) => (props.cardColor === "white" ? props.theme.grayscale.whiteGlass : props.theme.grayscale[20])};
    border: 2px solid ${(props) => (props.cardColor === "white" ? props.theme.grayscale.white : props.theme.grayscale[50])};
    border-radius: ${(props) => props.theme.radius.l};
`;
